import React from 'react'
import Hero from 'parts/AboutUs/Hero'
import Industries from 'parts/AboutUs/Industries'
import WorkWithUs from 'parts/AboutUs/WorkWithUs'
import VisionMission from 'parts/AboutUs/VisionMission'

const AboutUs = () => {
  return (
    <>
      <Hero />
      <VisionMission />
      <Industries />
      <WorkWithUs />
    </>
  )
}

export default AboutUs
